<div class="dependencies-group">
  <ng-template [ngIf]="hasDependencies">
    <div *ngFor="let campo of dependencies" class="dependencies-group-dependency">
      <app-dynamic-input
        [campo]="campo"
        [form]="form"
        [formGroup]="formGroup"
        class="dynamic-input"></app-dynamic-input>
    </div>
  </ng-template>
</div>
